import { useGetUser, useLogout } from '@/services/auth.service';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';
import PageHeader from '../../components/PageHeader';
import Section from '../../components/Section';
import { LogOutIcon } from 'lucide-react';

export default function User() {
    const { mutate: logout } = useLogout();
    const { data: user } = useGetUser();
    const { t } = useTranslation();

    return (
        <div className="max-w-3xl mx-auto px-8 py-10">
            <PageHeader title={t('Your profile')} />

            <Section>
                <div className="flex items-center justify-between gap-4">
                    {user && (
                        <div className="flex items-center gap-4 min-w-0">
                            <div className="h-16 w-16 flex-shrink-0 rounded-full bg-[#2d6a4f] text-white flex items-center justify-center text-xl font-semibold">
                                {user.firstName?.[0]}
                                {user.lastName?.[0]}
                            </div>
                            <div className="min-w-0">
                                <div className="text-lg font-semibold text-[#1c2620] truncate">
                                    {user.firstName} {user.lastName}
                                </div>
                                <div className="text-sm text-[#7a8077] truncate">
                                    {user.email}
                                </div>
                            </div>
                        </div>
                    )}
                    <Button
                        variant="outline"
                        onClick={() => logout()}
                        className="flex-shrink-0 border-red-200 text-red-600 hover:bg-red-50 hover:border-red-300"
                    >
                        <LogOutIcon className="h-4 w-4 mr-2" />
                        {t('Logout')}
                    </Button>
                </div>
            </Section>
        </div>
    );
}
